import { AppState } from '@core/state';
import { createChildSelectors } from '@util/lib/ngrx-child-selectors';

import { initialState } from './item.reducers';

export const selectItemState = (state: AppState) => state.item;

export const { selectItemLotNumberCheck } = createChildSelectors(selectItemState, initialState);
